var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.validData)?_c('div',{staticClass:"content"},[_c('RichTextRenderer',{attrs:{"document":_vm.document,"nodeRenderers":_vm.renderNode()}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }